export default {
  data() {
    return {
      accessibilityObserver: null,
    };
  },

  mounted() {
    this.setupAccessibilityObserver();
  },

  beforeDestroy() {
    this.cleanupAccessibilityObserver();
  },

  methods: {
    setupAccessibilityObserver() {
      // Create a MutationObserver to watch for aria-hidden changes
      this.accessibilityObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "aria-hidden"
          ) {
            this.handleAriaHiddenChange(mutation);
          }
        });
      });

      // Start observing the app element
      const appElement = document.getElementById("app");
      if (appElement) {
        this.accessibilityObserver.observe(appElement, {
          attributes: true,
          attributeFilter: ["aria-hidden"],
          subtree: true,
        });
      }
    },

    handleAriaHiddenChange(mutation) {
      const target = mutation.target;
      const isHidden = target.getAttribute("aria-hidden") === "true";

      if (isHidden) {
        // Check if any focused elements are descendants
        const focusedElement = document.activeElement;
        if (focusedElement && target.contains(focusedElement)) {
          // Remove aria-hidden to prevent accessibility violation
          target.removeAttribute("aria-hidden");

          // Alternative: use inert attribute instead
          if (target.hasAttribute("inert")) {
            target.removeAttribute("inert");
          }
        }
      }
    },

    cleanupAccessibilityObserver() {
      if (this.accessibilityObserver) {
        this.accessibilityObserver.disconnect();
        this.accessibilityObserver = null;
      }
    },

    // Method to safely show/hide content without breaking accessibility
    setContentVisibility(element, visible) {
      if (visible) {
        element.removeAttribute("aria-hidden");
        element.removeAttribute("inert");
      } else {
        // Use inert instead of aria-hidden when possible
        if (element.hasAttribute("inert")) {
          element.removeAttribute("inert");
        }
        element.setAttribute("aria-hidden", "true");
      }
    },
  },
};
